import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=f26da216&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=f26da216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26da216",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GlobalQueryBox: require('/home/vsts/work/1/s/components/global/QueryBox.vue').default,GlobalChart: require('/home/vsts/work/1/s/components/global/Chart.vue').default})
